import { filterLocale, lookupLocale } from '@plato/shared-util/locale';

export const supportedLanguages = ['de', 'en', 'fr'] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

export const defaultLanguage: SupportedLanguage = 'de';

const defaultLocales: Record<string, string> = {
    // our first french language customers are Swiss
    fr: 'fr-CH',
} satisfies Partial<Record<SupportedLanguage, string>>;

/**
 * Matches a supported language to the given language tag.
 */
export function resolveLanguage(desiredLanguage?: string | string[]): SupportedLanguage {
    if (!desiredLanguage?.length) {
        return defaultLanguage;
    }
    return lookupLocale(supportedLanguages, desiredLanguage) ?? defaultLanguage;
}

export function resolveLocale(language: string, userLocales: string[] = []): string {
    const defaultLocale = defaultLocales[language];
    // default goes at the end so it's less specific than anything the user sets
    const locales = defaultLocale ? userLocales.concat([defaultLanguage]) : userLocales;
    return filterLocale(locales, language)[0] ?? language;
}
